package fr.frux.shared.domain.repository

import fr.frux.shared.domain.model.NotificationPage
import fr.frux.shared.domain.model.NotificationPreferences

/**
 * Repository interface pour le socle de notifications (#225 P0, ADR 0017).
 */
interface NotificationRepository {
    /**
     * Page de notifications, [beforeId] est le curseur reçu de la page précédente (`null` pour la
     * première page). Sans cache local pour l'instant (même choix que [HarvestRepository.getHarvestById]).
     */
    suspend fun getNotifications(
        beforeId: Long? = null,
        limit: Int = 20,
    ): Result<NotificationPage>

    /** Marque les notifications [ids] comme lues. */
    suspend fun markRead(ids: List<Long>): Result<Unit>

    /** Marque toutes les notifications comme lues. */
    suspend fun markAllRead(): Result<Unit>

    /** Préférences de notification de l'utilisateur courant. */
    suspend fun getPreferences(): Result<NotificationPreferences>

    /**
     * Met à jour les préférences email/push/catégories. `inAppEnabled` n'est jamais transmis :
     * non modifiable côté serveur (D9, ADR 0017).
     */
    suspend fun updatePreferences(
        emailEnabled: Boolean,
        pushEnabled: Boolean,
        harvestEvents: Boolean,
        treeEvents: Boolean,
        maturityAlerts: Boolean,
    ): Result<NotificationPreferences>

    /** Enregistre le jeton d'appareil courant (#252 P2). Idempotent côté serveur. */
    suspend fun registerPushToken(token: String): Result<Unit>

    /** Révoque le jeton d'appareil courant (déconnexion). Idempotent, y compris sur un jeton inconnu. */
    suspend fun revokePushToken(token: String): Result<Unit>
}
